
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import { DocumentationLayout as _Layout } from '@/layouts/DocumentationLayout'
import { ContentsLayout as _Default } from '@/layouts/ContentsLayout'
const Layout = _Layout;
const meta = {
  "title": "Custom Event Tracking",
  "date": "2022-08-19"
};
const slug = 'tracking';
const tableOfContents = [{
  "title": "User Registration",
  "slug": "user-registration",
  "children": []
}, {
  "title": "Purchase Journey",
  "slug": "purchase-journey",
  "children": []
}, {
  "title": "Others",
  "slug": "others",
  "children": []
}, {
  "title": "Listing (for Marketplaces)",
  "slug": "listing-for-marketplaces",
  "children": []
}, {
  "title": "Account (for Marketplaces)",
  "slug": "account-for-marketplaces",
  "children": []
}];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = _Default
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">






    <p>{`Custom Event Tracking is useful for you to track the behaviour/action happening in your platform. Measuring these events allow you to see where is your user drop off, converts, etc. By default, this custom event tracking has been configured and available in all hosted `}<_Link href="/templates" passHref><a>{`web templates`}</a></_Link>{`. You may use this events under Google Tag Manager for creating different triggers to use for tags like GA4, `}<_Link href="/resources/googletagmanager/facebookpixel" passHref><a>{`Facebook`}</a></_Link>{`, Mixpanel, etc. `}</p>
    <_Heading level={2} id={"user-registration"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>User Registration</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Sign In (sign_in): This event is triggered when a user signs in to their account on the website. The “Values” field may include the email or phone number used to sign in.`}</li>
      <li parentName="ul">{`Sign Up (sign_up): This event is triggered when a user signs up for a new account on the website. The “Values” field may include the username, email, or phone number used to sign up. The “Property” field may include a “step” value of “signup start” to indicate the beginning of the sign-up process.`}</li>
      <li parentName="ul">{`Verify Page (verify_page): This event is triggered when a user verifies their account or email address on the website. The “Values” field may include details about the verification process.`}</li>
      <li parentName="ul">{`Edit Profile (edit_profile): This event is triggered when a user edits their profile on the website.`}</li>
    </ul>
    <_Heading level={2} id={"purchase-journey"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>Purchase Journey</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Add to Cart (add_cart): This event is triggered when a user adds a listing to their cart. The “Values” field may include the listing title, price, slug, category name, and image.`}</li>
      <li parentName="ul">{`Buy Now (buynow): This event is triggered when a user purchases a listing using the “Buy Now” feature. The “Values” field may include the listing title, price, slug, category name, and image.`}</li>
      <li parentName="ul">{`Checkout (checkout): This event is triggered when a user begins the checkout process for a purchase. The “Values” field may include the listing title, price, slug, category name, image, whole price, shipment name, payment name, and grand total.`}</li>
    </ul>
    <_Heading level={2} id={"others"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>Others</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Add Address (add_address): This event is triggered when a user adds a new address to their account.`}</li>
      <li parentName="ul">{`Edit Address (edit_address): This event is triggered when a user edits an existing address in their account.`}</li>
      <li parentName="ul">{`Page View: This event is triggered when a user views a page on the website. The “Values” field may include the slug of the page being viewed.`}</li>
    </ul>
    <_Heading level={2} id={"listing-for-marketplaces"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>Listing (for Marketplaces)</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Add Listing (add_listing): This event is triggered when a user adds a new listing to the website.`}</li>
      <li parentName="ul">{`Edit Listing (edit_listing): This event is triggered when a user edits an existing listing on the website.`}</li>
      <li parentName="ul">{`Listing View (listing_view): This event is triggered when a user views a listing on the website. The “Values” field may include the listing slug, title, and price.`}</li>
      <li parentName="ul">{`Listing Detail Page`}</li>
    </ul>
    <_Heading level={2} id={"account-for-marketplaces"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": true
    }}>Account (for Marketplaces)</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">
        <p parentName="li">{`Create Account (create_account): This event is triggered when a user creates a new account on the website.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Edit Account (edit_account): This event is triggered when a user edits an existing account on the website.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Account View (account_view): This event is triggered when a user views an account on the website. The “Values” field may include the account slug and title.`}</p>
      </li>
    </ul>
    <table className="text-lg border border-gray-300">
      <thead>
  <tr>
    <th>Event Name</th>
    <th>Event Values</th>
  </tr>
      </thead>
      <tbody>
  <tr>
    <td>Add Listing (add_listing)</td>
    <td>N/A</td>
  </tr>
  <tr>
    <td>Edit Listing (edit_listing)</td>
    <td>N/A</td>
  </tr>
  <tr>
    <td>Create Account (create_account)</td>
    <td>N/A</td>
  </tr>
  <tr>
    <td>Edit Account (edit_account)</td>
    <td>N/A</td>
  </tr>
  <tr>
    <td>Add Address (add_address)</td>
    <td>N/A</td>
  </tr>
  <tr>
    <td>Edit Address (edit_address)</td>
    <td>N/A</td>
  </tr>
  <tr>
    <td>Sign In (sign_in)</td>
    <td>Email, Phone Number</td>
  </tr>
  <tr>
    <td>Sign Up (sign_up)</td>
    <td>Username, Email, Phone Number</td>
  </tr>
  <tr>
    <td>Verify Page (verify_page)</td>
    <td>N/A</td>
  </tr>
  <tr>
    <td>Edit Profile (edit_profile)</td>
    <td>N/A</td>
  </tr>
  <tr>
    <td>Listing View (listing_view)</td>
    <td>Listing Slug, Title, Price</td>
  </tr>
  <tr>
    <td>Account View (account_view)</td>
    <td>Account Slug, Title</td>
  </tr>
  <tr>
    <td>Listing Detail Page</td>
    <td>N/A</td>
  </tr>
  <tr>
    <td>Add to Cart (add_cart)</td>
    <td>Listing Title, Price, Slug, Category Name, Image</td>
  </tr>
  <tr>
    <td>Buy Now (buynow)</td>
    <td>Listing Title, Price, Slug, Category Name, Image</td>
  </tr>
  <tr>
    <td>Checkout (checkout)</td>
    <td>Listing Title, Price, Slug, Category Name, Image, Whole price, Shipment Name, Payment Name, Grand Total</td>
  </tr>
  <tr>
    <td>Page View</td>
    <td>Slug</td>
  </tr>
      </tbody>
    </table>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
